import { Typography, TypographyProps, Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { RouteLink, Types } from '@scorenco/core';

import { getEventTeams } from '../utils/eventGuards';

type EventTitleProps = TypographyProps & {
  event?: Types.Competitions_Event_Detail;
  tournamentUrl?: string;
};

export const EventTitle = ({
  event,
  tournamentUrl,
  sx,
  ...rest
}: EventTitleProps) => {
  const teams = getEventTeams(event?.teams);

  return (
    <Typography
      variant="h3"
      component="h1"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...sx,
      }}
      {...rest}
    >
      <Box
        component={RouteLink}
        href={tournamentUrl || teams[0]?.url}
        flex={1}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {teams[0]?.name_in_competition || <Skeleton width={120} />}
      </Box>

      <Box component="span" fontSize="0.5em">
        contre
      </Box>

      <Box
        component={RouteLink}
        href={tournamentUrl || teams[1]?.url}
        flex={1}
        textAlign="right"
        sx={{
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {teams[1]?.name_in_competition || (
          <Skeleton sx={{ mr: 0, ml: 'auto' }} width={120} />
        )}
      </Box>
    </Typography>
  );
};
